import script from "./agentList.vue?vue&type=script&setup=true&lang=js"
export * from "./agentList.vue?vue&type=script&setup=true&lang=js"

import "./agentList.vue?vue&type=style&index=0&id=d6c64b4e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6c64b4e"]])

export default __exports__